// extracted by mini-css-extract-plugin
export default {"add-btn":"SceneGroup_add-btn__sk5Ri"};